export default __webpack_public_path__ + "static/media/pic1.314f0e72.jpg";